import * as React from 'react';

import styles from './style.scss';

export const FoodDriverHelpTextSpan = (
  props: React.HTMLAttributes<HTMLSpanElement>
) => {
  return (
    <span {...props} className={styles.helpText}>
      {props.children}
    </span>
  );
};
